import ScrollReveal from "scrollreveal";

const defaultOptions = {
	duration: 750,
	viewFactor: 0.5,
};

ScrollReveal({ distance: 0 }).reveal(
	"main .wp-block-heading, main .wp-block-image, main p, main li, main .wp-block-button, main .wp-block-contact-form-7-contact-form-selector__field, main .wpcf7-submit, main .wp-block-navigation-item",
	{
		...defaultOptions,
	},
);
